export function parseQueryString(queryString: string): Record<string, string> {
  const query = {};
  const pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&");
  pairs.forEach((entry) => {
    const pair = entry.split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  });
  return query;
}
